(() => {
  const track = document.querySelector('.ibn-announcement__track');
  const firstGroup = track?.querySelector('.ibn-announcement__group');
  if (!(track instanceof HTMLElement) || !(firstGroup instanceof HTMLElement)) return;

  let frame = 0;

  const measureAndRestart = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const distance = firstGroup.getBoundingClientRect().width;
      if (distance <= 0) return;

      track.style.setProperty('--ibn-announcement-distance', `-${distance}px`);
      track.style.animation = 'none';
      void track.offsetWidth;
      track.style.removeProperty('animation');
    });
  };

  const resizeObserver = new ResizeObserver(measureAndRestart);
  resizeObserver.observe(firstGroup);

  document.addEventListener('ibn:languagechange', measureAndRestart);
  if (document.fonts?.ready) {
    document.fonts.ready.then(measureAndRestart).catch(() => {});
  }
  measureAndRestart();
})();
